export default __webpack_public_path__ + "static/media/img10.26ed615f.png";